// extracted by mini-css-extract-plugin
export default {"DestinationImage":"DestinationImage_DestinationImage__KbwSY","Image":"DestinationImage_Image__el69z"};